import './Header.scss';

import React, { useState } from 'react';
import { generatePath } from 'react-router-dom';

import { ReactComponent as Logo } from '@assets/images/logo.svg';
import Button, { ButtonStyle } from '@components/Button';
import Profile from '@components/Profile';
import { RoutePath } from '@constants/route-path';
import { IUser } from '@models/user';

interface IProps {
  user: IUser;
}

function Header({ user }: IProps) {
  const [showNotifs, setShowNotifs] = useState(false);
  const [newNotifs, setNewNotifs] = useState(false);

  const toggleNotifs = () => {
    if (!showPopup) {
      setShowNotifs(!showNotifs);
    } else {
      togglePopup();
      setShowNotifs(!showNotifs);
    }
  };

  const [showPopup, setShowPopup] = useState(false);

  const togglePopup = () => {
    if (!showNotifs) {
      setShowPopup(!showPopup);
    } else {
      toggleNotifs();
      setShowPopup(!showPopup);
    }
  };

  const numNotifs = 0;

  return (
    <header className="modHeader">
      <Logo className="modHeader__logo" />
      <div className="modHeader__menu">
        <button
          className={`modHeaderNotification${newNotifs ? ' modHeaderNotification--unread' : ''}`}
          onClick={toggleNotifs}>
          <i className="modIcon modIcon--bell" />
        </button>
        {showNotifs && (
          <div className="modHeader__notifs">
            {newNotifs ? (
              <div>
                <div className="modHeader__numNotifs">
                  <h3>{numNotifs} new notifications!</h3>
                </div>
                <div>
                  <Button type="link" style={ButtonStyle.Profile} to={generatePath(RoutePath.ProfilePage)}>
                    View in Notifications center
                  </Button>
                </div>
              </div>
            ) : (
              <div>
                <b>No notifications</b>
              </div>
            )}
          </div>
        )}
        <div className="modHeader__menu__separator" />
        <Profile user={user} popupStatus={showPopup} callback={togglePopup} />
      </div>
    </header>
  );
}

export default Header;
